import React from "react";
import { Button, CircularProgress, TextField } from "@mui/material";
import { Image } from "mui-image";

export default function AccountCategorySelect({
  categories = [],
  selectedType = {},
  selectedSubTypes = [],
  setSelectedSubTypes = () => {},
  verifying = false,
  categorySubmitHandler = () => {},
}) {
  const [otherExpertise, setOtherExpertise] = React.useState("");
  const [otherSelected, setOtherSelected] = React.useState(false);
  const [error, setError] = React.useState({ otherExpertise: false });

  const bottomRef = React.useRef(null);

  React.useEffect(() => {
    selectedSubTypes.forEach((st) => {
      if (
        st.category_id === 11 ||
        st.category_id === 27 ||
        st.category_id === 28
      ) {
        setOtherSelected(true);
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      } else {
        setOtherSelected(false);
      }
    });
  }, [selectedSubTypes]);

  return (
    <>
      <div className="request-subtype-wrapper">
        <span>
          {selectedType?.admin_type_id === 1 ? (
            <>What is your expertise?</>
          ) : (
            <>Choose your category</>
          )}
        </span>
        <div className="request-sub-types">
          {categories.map((category, index) => {
            const selectedCategory = selectedSubTypes.some(
              (selected) => category.category_id === selected.category_id
            );
            return (
              <div
                style={{
                  padding: "1px",
                  background:
                    "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                  marginRight: "2%",

                  marginBottom: "1rem",
                  borderRadius: 12,
                  width: "30%",
                  height: "120px",
                }}
              >
                <div
                  onClick={() => {
                    selectedCategory
                      ? setSelectedSubTypes(
                          selectedSubTypes.filter(
                            (selected) =>
                              selected.category_id !== category.category_id
                          )
                        )
                      : setSelectedSubTypes([...selectedSubTypes, category]);
                  }}
                  className={`request-sub-type ${
                    selectedCategory ? "selected-sub-type" : ""
                  }`}
                  style={{
                    marginBottom: 0,
                    // width: 0,
                    // height: 0,
                  }}
                  key={index}
                >
                  <div className="request-sub-type-icon">
                    <Image
                      height="100%"
                      width="100%"
                      fit="contain"
                      duration={800}
                      src={
                        selectedCategory
                          ? category.inactive_icon
                          : category.active_icon
                      }
                      alt=""
                    />
                  </div>
                  <span
                    style={{
                      color: selectedCategory ? "#222831" : "#fff",
                      fontWeight: "500",
                      fontSize: "15.6053px",
                      paddingTop: "0.5rem",
                      textTransform: "capitalize",
                    }}
                  >
                    {category.category_name}
                  </span>
                </div>
              </div>
            );
          })}
          {!categories.length && (
            <div style={{ margin: "2rem auto" }}>
              <CircularProgress />
            </div>
          )}
        </div>
        <div>
          {selectedSubTypes.map((type, index) => {
            if (
              type.category_id === 11 ||
              type.category_id === 27 ||
              type.category_id === 28
            ) {
              return (
                <div
                  style={{ marginTop: "16px", textAlign: "left" }}
                  ref={bottomRef}
                  className="other-expertise"
                >
                  <span style={{ fontSize: "18px", fontWeight: 400 }}>
                    {selectedType?.admin_type_id === 1
                      ? "Please enter other expertise"
                      : "Please enter category"}
                  </span>
                  <TextField
                    label="Other expertise"
                    value={otherExpertise}
                    onChange={(e) => {
                      setError({
                        ...error,
                        otherExpertise: e.target.value ? false : true,
                      });
                      setOtherExpertise(e.target.value);
                    }}
                    error={error.otherExpertise}
                    helperText={
                      error.otherExpertise
                        ? "Please enter other expertise"
                        : " "
                    }
                    disabled={verifying}
                    style={{ margin: "0.5rem 0rem" }}
                    placeholder="Ex. expertise"
                    fullWidth
                    focused
                  />
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
      <div className="request-footer-btn">
        <Button
          id="step-6-onboarding"
          disabled={
            verifying ||
            !selectedSubTypes.length ||
            (otherExpertise === "" && otherSelected)
          }
          onClick={() => categorySubmitHandler(otherExpertise)}
          fullWidth
          variant="contained"
          size="large"
          style={{
            padding: "16px 0",
            fontSize: "1em",
            background:
              verifying ||
              !selectedSubTypes.length ||
              (otherExpertise === "" && otherSelected)
                ? "#383838"
                : "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
            color:
              verifying ||
              !selectedSubTypes.length ||
              (otherExpertise === "" && otherSelected)
                ? "#232323"
                : "#FF4A01",
          }}
        >
          {verifying ? "Submitting..." : "Continue"}
        </Button>
      </div>
    </>
  );
}
